import { Platform } from 'react-native';

import { client } from '..';
import { InfluencerDiscount, Show, ShowEpisode } from '../models/showModels';

export const getAllShows = async (): Promise<Show> => {
  const url = `/shows`;
  const { data } = await client.get(url);

  // ToDO: Check this BE data, releaseDate comes outside of show object and is not an array
  const show = data['0'];
  return {
    ...show,
    releaseDate: data.releaseDate
  };
};

export const getAllChaptersOfShow = async ({
  showId,
  order = 'asc'
}: {
  showId: string;
  order?: string;
}): Promise<ShowEpisode[]> => {
  const url = `/shows/${showId}/chapters?order=${order}`;
  const { data } = await client.get(url);

  return data;
};

export const getUserPurchasedShows = async (): Promise<any> => {
  const url = `/shows/user`;
  const { data } = await client.get(url);

  return data;
};

export const purchaseShow = async ({
  showId,
  key,
  paymentType,
  code
}: {
  showId: string;
  key: string;
  paymentType: 'CREDIT_CARD' | 'ACH';
  code?: string;
}): Promise<any> => {
  const url = `/shows/purchase`;
  const { data } = await client.post(url, {
    showId,
    key,
    paymentType,
    code,
    source: Platform.OS === 'web' ? 'BS_WEB' : 'BS_MOBILE'
  });

  return data;
};

export const authenticateEpisode = async ({
  episodeId
}: {
  episodeId: string;
}): Promise<{ playbackId: string; token: string; drmToken?: string }> => {
  const url = `/shows/episode`;
  const { data } = await client.post(url, {
    episodeId
  });

  return data;
};

export const getInfluencerDiscount = async ({
  influencerCode
}: {
  influencerCode: string;
}): Promise<InfluencerDiscount> => {
  const url = `/shows/influencers/discount/${influencerCode}`;
  const { data } = await client.get(url);

  return data;
};
